/* lua.js generated code 0.3.0 */

cc = cc || {}
// cc.clampf = function (value, min_inclusive, max_inclusive) {
//     // body
//     var temp = 0
//     if (min_inclusive > max_inclusive) {
//         temp = min_inclusive
//         min_inclusive = max_inclusive
//         max_inclusive = temp
//     }
//     if (value < min_inclusive) {
//         return min_inclusive
//     } else if (value < max_inclusive) {
//         return value
//     } else {
//         return max_inclusive
//     }
// }
// //Point
// cc.p = function (_x, _y) {
//     if (null == _y) {
//         return { x: _x.x, y: _x.y }
//     } else {
//         return { x: _x, y: _y }
//     }
// }
// cc.pAdd = function (pt1, pt2) {
//     return { x: pt1.x + pt2.x, y: pt1.y + pt2.y }
// }
// cc.pSub = function (pt1, pt2) {
//     return { x: pt1.x - pt2.x, y: pt1.y - pt2.y }
// }
cc.pMul = function (pt1, factor) {
    return {
        x: pt1.x * factor,
        y: pt1.y * factor
    }
}
cc.pMulp = function (pt1, pt2) {
    return {
        x: pt1.x * pt2.x,
        y: pt1.y * pt2.y
    }
}
// cc.pMidpoint = function (pt1, pt2) {
//     return { x: (pt1.x + pt2.x) / 2.0, y: (pt1.y + pt2.y) / 2.0 }
// }
// cc.pForAngle = function (a) {
//     return { x: Math.cos(a), y: Math.sin(a) }
// }
cc.pGetLength = function (pt) {
    return Math.sqrt(pt.x * pt.x + pt.y * pt.y)
}
// cc.pNormalize = function (pt) {
//     var length = cc.pGetLength(pt)
//     if (0 === length) {
//         return { x: 1.0, y: 0.0 }
//     }
//     return { x: pt.x / length, y: pt.y / length }
// }
// cc.pCross = function (self, other) {
//     return self.x * other.y - self.y * other.x
// }
// cc.pDot = function (self, other) {
//     return self.x * other.x + self.y * other.y
// }
cc.pToAngleSelf = function (self) {
    return Math.atan2(self.y, self.x)
}
cc.pGetAngle = function (self, other) {
    var a2 = cc.pNormalize(self)
    var b2 = cc.pNormalize(other)
    var angle = Math.atan2(cc.pCross(a2, b2), cc.pDot(a2, b2))
    if (Math.abs(angle) < 1.192092896e-7) {
        return 0.0
    }
    return angle
}
cc.pGetDistance = function (startP, endP) {
    return cc.pGetLength(cc.pSub(startP, endP))
}
cc.pIsLineIntersect = function (A, B, C, D, s, t) {
    if (((A.x === B.x) && (A.y === B.y)) || ((C.x === D.x) && (C.y === D.y))) {
        // FIXME: multi result
        return [false, s, t]
    }
    var BAx = B.x - A.x
    var BAy = B.y - A.y
    var DCx = D.x - C.x
    var DCy = D.y - C.y
    var ACx = A.x - C.x
    var ACy = A.y - C.y
    var denom = DCy * BAx - DCx * BAy
    s = DCx * ACy - DCy * ACx
    t = BAx * ACy - BAy * ACx
    if ((denom === 0)) {
        if ((s === 0 || t === 0)) {
            // FIXME: multi result
            return [true, s, t]
        }
        // FIXME: multi result
        return [false, s, t]
    }
    s = s / denom
    t = t / denom
    // FIXME: multi result
    return [true, s, t]
}
// cc.pPerp = function (pt) {
//     return { x: -pt.y, y: pt.x }
// }
// cc.RPerp = function (pt) {
//     return { x: pt.y, y: -pt.x }
// }
// cc.pProject = function (pt1, pt2) {
//     return { x: pt2.x * (cc.pDot(pt1, pt2) / cc.pDot(pt2, pt2)), y: pt2.y * (cc.pDot(pt1, pt2) / cc.pDot(pt2, pt2)) }
// }
// cc.pRotate = function (pt1, pt2) {
//     return { x: pt1.x * pt2.x - pt1.y * pt2.y, y: pt1.x * pt2.y + pt1.y * pt2.x }
// }
// cc.pUnrotate = function (pt1, pt2) {
//     return table([1, "x", pt1.x * pt2.x + pt1.y * pt2.y], [0, pt1.y * pt2.x - pt1.x * pt2.y])
// }
// //Calculates the square length of pt
// cc.pLengthSQ = function (pt) {
//     // WARN: maybe multi result
//     return cc.pDot(pt, pt)
// }
// //Calculates the square distance between pt1 and pt2
// cc.pDistanceSQ = function (pt1, pt2) {
//     // WARN: maybe multi result
//     return cc.pLengthSQ(cc.pSub(pt1, pt2))
// }
// cc.pGetClampPoint = function (pt1, pt2, pt3) {
//     return { x: cc.clampf(pt1.x, pt2.x, pt3.x), y: cc.clampf(pt1.y, pt2.y, pt3.y) }
// }
// cc.pFromSize = function (sz) {
//     return { x: sz.width, y: sz.height }
// }
// cc.pLerp = function (pt1, pt2, alpha) {
//     // WARN: maybe multi result
//     return cc.pAdd(cc.pMul(pt1, 1.0 - alpha), cc.pMul(pt2, alpha))
// }
// cc.pFuzzyEqual = function (pt1, pt2, variance) {
//     if ((pt1.x - variance <= pt2.x) && (pt2.x <= pt1.x + variance) && (pt1.y - variance <= pt2.y) && (pt2.y <= pt1.y + variance)) {
//         return true
//     } else {
//         return false
//     }
// }
cc.pRotateByAngle = function (pt1, pt2, angle) {
    return cc.pAdd(pt2, cc.pRotate(cc.pSub(pt1, pt2), cc.pForAngle(angle)))
}
// cc.pIsSegmentIntersect = function (pt1, pt2, pt3, pt4) {
//     var [s, t, ret] = [0, 0, false]
//     ;[ret, s, t] = cc.pIsLineIntersect(pt1, pt2, pt3, pt4, s, t)
//     if (ret && s >= 0.0 && s <= 1.0 && t >= 0.0 && t <= 0.0) {
//         return true
//     }
//     return false
// }
// cc.pGetIntersectPoint = function (pt1, pt2, pt3, pt4) {
//     var [s, t, ret] = [0, 0, false]
//     ;[ret, s, t] = cc.pIsLineIntersect(pt1, pt2, pt3, pt4, s, t)
//     if (ret) {
//         // WARN: maybe multi result
//         return cc.p(pt1.x + s * (pt2.x - pt1.x), pt1.y + s * (pt2.y - pt1.y))
//     } else {
//         // WARN: maybe multi result
//         return cc.p(0, 0)
//     }
// }
//Size
// cc.size = function (_width, _height) {
//     return { width: _width, height: _height }
// }
//Rect
// cc.rect = function (_x, _y, _width, _height) {
//     return table(
//         [1, "x", _x],
//         [1, "y", _y],
//         [1, "width", _width],
//         [1, "height", _height]
//     )
// }
// cc.rectEqualToRect = function (rect1, rect2) {
//     if (((rect1.x >= rect2.x) || (rect1.y >= rect2.y) || (rect1.x + rect1.width <= rect2.x + rect2.width) || (rect1.y + rect1.height <= rect2.y + rect2.height))) {
//         return false
//     }
//     return true
// }
// cc.rectGetMaxX = function (rect) {
//     return rect.x + rect.width
// }
// cc.rectGetMidX = function (rect) {
//     return rect.x + rect.width / 2.0
// }
// cc.rectGetMinX = function (rect) {
//     return rect.x
// }
// cc.rectGetMaxY = function (rect) {
//     return rect.y + rect.height
// }
// cc.rectGetMidY = function (rect) {
//     return rect.y + rect.height / 2.0
// }
// cc.rectGetMinY = function (rect) {
//     return rect.y
// }
// cc.rectContainsPoint = function (rect, point) {
//     var ret = false
//     if ((point.x >= rect.x) && (point.x <= rect.x + rect.width) && (point.y >= rect.y) && (point.y <= rect.y + rect.height)) {
//         ret = true
//     }
//     return ret
// }
// cc.rectIntersectsRect = function (rect1, rect2) {
//     var intersect = !(rect1.x > rect2.x + rect2.width || rect1.x + rect1.width < rect2.x || rect1.y > rect2.y + rect2.height || rect1.y + rect1.height < rect2.y)
//     return intersect
// }
// cc.rectUnion = function (rect1, rect2) {
//     var rect = cc.rect(0, 0, 0, 0)
//     rect.x = Math.min(rect1.x, rect2.x)
//     rect.y = Math.min(rect1.y, rect2.y)
//     rect.width = Math.max(rect1.x + rect1.width, rect2.x + rect2.width) - rect.x
//     rect.height = Math.max(rect1.y + rect1.height, rect2.y + rect2.height) - rect.y
//     return rect
// }
// cc.rectIntersection = function (rect1, rect2) {
//     var intersection = cc.rect(Math.max(rect1.x, rect2.x), Math.max(rect1.y, rect2.y), 0, 0)
//     intersection.width = Math.min(rect1.x + rect1.width, rect2.x + rect2.width) - intersection.x
//     intersection.height = Math.min(rect1.y + rect1.height, rect2.y + rect2.height) - intersection.y
//     return intersection
// }
//Color3B
cc.c3b = function(_r, _g, _b) {
    return { r: _r, g: _g, b: _b }
}
//Color4B
cc.c4b = function(_r, _g, _b, _a) {
    return { r: _r, g: _g, b: _b, a: _a }
}
//Color4F
cc.c4f = function(_r, _g, _b, _a) {
    return { r: _r, g: _g, b: _b, a: _a }
}
function isFloatColor(c) {
    return (c.r <= 1 && c.g <= 1 && c.b <= 1) && (Math.ceil(c.r) !== c.r || Math.ceil(c.g) !== c.g || Math.ceil(c.b) !== c.b)
}
cc.convertColor = function (input, typ) {
    assert(type(input) === "table" && $bool(input.r) && $bool(input.g) && $bool(input.b), "cc.convertColor() - invalid input color")
    var ret
    if (typ === "3b") {
        if (isFloatColor(input)) {
            ret = table(
                [1, "r", Math.ceil(input.r * 255)],
                [1, "g", Math.ceil(input.g * 255)],
                [1, "b", Math.ceil(input.b * 255)]
            )
        } else {
            ret = table(
                [1, "r", input.r],
                [1, "g", input.g],
                [1, "b", input.b]
            )
        }
    } else if (typ === "4b") {
        if (isFloatColor(input)) {
            ret = table(
                [1, "r", Math.ceil(input.r * 255)],
                [1, "g", Math.ceil(input.g * 255)],
                [1, "b", Math.ceil(input.b * 255)]
            )
        } else {
            ret = table(
                [1, "r", input.r],
                [1, "g", input.g],
                [1, "b", input.b]
            )
        }
        if (input.a) {
            if (Math.ceil(input.a) !== input.a || input.a >= 1) {
                ret.a = input.a * 255
            } else {
                ret.a = input.a
            }
        } else {
            ret.a = 255
        }
    } else if (typ === "4f") {
        if (isFloatColor(input)) {
            ret = table(
                [1, "r", input.r],
                [1, "g", input.g],
                [1, "b", input.b]
            )
        } else {
            ret = table(
                [1, "r", input.r / 255],
                [1, "g", input.g / 255],
                [1, "b", input.b / 255]
            )
        }
        if (input.a) {
            if (Math.ceil(input.a) !== input.a || input.a >= 1) {
                ret.a = input.a
            } else {
                ret.a = input.a / 255
            }
        } else {
            ret.a = 255
        }
    } else {
        error(string.format("cc.convertColor() - invalid type %s", typ), 0)
    }
    return ret
}
// //Vertex2F
// cc.vertex2F = function (_x, _y) {
//     return { x: _x, y: _y }
// }
// //Vertex3F
// cc.Vertex3F = function (_x, _y, _z) {
//     return table(
//         [1, "x", _x],
//         [1, "y", _y],
//         [1, "z", _z]
//     )
// }
// //Tex2F
// cc.tex2F = function (_u, _v) {
//     return table([1, "u", _u], [1, "v", _v])
// }
// //PointSprite
// cc.PointSprite = function (_pos, _color, _size) {
//     return table(
//         [1, "pos", _pos],
//         [1, "color", _color],
//         [1, "size", _size]
//     )
// }
// //Quad2
// cc.Quad2 = function (_tl, _tr, _bl, _br) {
//     return table(
//         [1, "tl", _tl],
//         [1, "tr", _tr],
//         [1, "bl", _bl],
//         [1, "br", _br]
//     )
// }
// //Quad3
// cc.Quad3 = function (_tl, _tr, _bl, _br) {
//     return table(
//         [1, "tl", _tl],
//         [1, "tr", _tr],
//         [1, "bl", _bl],
//         [1, "br", _br]
//     )
// }
// //V2F_C4B_T2F
// cc.V2F_C4B_T2F = function (_vertices, _colors, _texCoords) {
//     return table(
//         [1, "vertices", _vertices],
//         [1, "colors", _colors],
//         [1, "texCoords", _texCoords]
//     )
// }
// //V2F_C4F_T2F
// cc.V2F_C4F_T2F = function (_vertices, _colors, _texCoords) {
//     return table(
//         [1, "vertices", _vertices],
//         [1, "colors", _colors],
//         [1, "texCoords", _texCoords]
//     )
// }
// //V3F_C4B_T2F
// cc.V3F_C4B_T2F = function (_vertices, _colors, _texCoords) {
//     return table(
//         [1, "vertices", _vertices],
//         [1, "colors", _colors],
//         [1, "texCoords", _texCoords]
//     )
// }
// //V2F_C4B_T2F_Quad
// cc.V2F_C4B_T2F_Quad = function (_bl, _br, _tl, _tr) {
//     return table(
//         [1, "bl", _bl],
//         [1, "br", _br],
//         [1, "tl", _tl],
//         [1, "tr", _tr]
//     )
// }
// //V3F_C4B_T2F_Quad
// cc.V3F_C4B_T2F_Quad = function (_tl, _bl, _tr, _br) {
//     return table(
//         [1, "tl", _tl],
//         [1, "bl", _bl],
//         [1, "tr", _tr],
//         [1, "br", _br]
//     )
// }
// //V2F_C4F_T2F_Quad
// cc.V2F_C4F_T2F_Quad = function (_bl, _br, _tl, _tr) {
//     return table(
//         [1, "bl", _bl],
//         [1, "br", _br],
//         [1, "tl", _tl],
//         [1, "tr", _tr]
//     )
// }
// //T2F_Quad
// cc.T2F_Quad = function (_bl, _br, _tl, _tr) {
//     return table(
//         [1, "bl", _bl],
//         [1, "br", _br],
//         [1, "tl", _tl],
//         [1, "tr", _tr]
//     )
// }
// //AnimationFrameData
// cc.AnimationFrameData = function (_texCoords, _delay, _size) {
//     return table(
//         [1, "texCoords", _texCoords],
//         [1, "delay", _delay],
//         [1, "size", _size]
//     )
// }
// //PhysicsMaterial
// cc.PhysicsMaterial = function (_density, _restitution, _friction) {
//     return table(
//         [1, "density", _density],
//         [1, "restitution", _restitution],
//         [1, "friction", _friction]
//     )
// }
cc.vec3 = cc.ccc3
cc.vec4 = cc.ccc4
// cc.vec3normalize = function (vec3) {
//     var n = vec3.x * vec3.x + vec3.y * vec3.y + vec3.z * vec3.z
//     if (n === 1.0) {
//         return vec3
//     }
//     n = Math.sqrt(n)
//     if (n < 2e-37) {
//         return vec3
//     }
//     n = 1.0 / n
//     return table(
//         [1, "x", vec3.x * n],
//         [1, "y", vec3.y * n],
//         [1, "z", vec3.z * n]
//     )
// }
// cc.quaternion = function (_x, _y, _z, _w) {
//     return table(
//         [1, "x", _x],
//         [1, "y", _y],
//         [1, "z", _z],
//         [1, "w", _w]
//     )
// }
cc.blendFunc = cc.BlendFunc
// cc.mat4 = cc.mat4 || table()
// cc.mat4.new = function () {
//     var __VA_ARG = $slice(arguments, 0)
//     var params = table([2, __VA_ARG])
//     var size = $len(params)
//     var obj = table()
//     if (1 === size) {
//         assert(type(params[1]) === "table", "type of input params are wrong to new a mat4 when num of params is 1")
//         for (var i = 1; i <= 16; i += 1) {
//             if (params[1][i] != null) {
//                 obj[i] = params[1][i]
//             } else {
//                 obj[i] = 0
//             }
//         }
//     } else if (16 === size) {
//         for (var i = 1; i <= 16; i += 1) {
//             obj[i] = params[i]
//         }
//     }
//     setmetatable(obj, table([1, "__index", cc.mat4]))
//     return obj
// }
// cc.mat4.getInversed = function (self) {
//     // WARN: maybe multi result
//     return mat4_getInversed(self)
// }
// cc.mat4.transformVector = function (self, vector, dst) {
//     // WARN: maybe multi result
//     return mat4_transformVector(self, vector, dst)
// }
// cc.mat4.multiply = function (self, mat) {
//     // WARN: maybe multi result
//     return mat4_multiply(self, mat)
// }
// cc.mat4.decompose = function (self, scale, rotation, translation) {
//     // WARN: maybe multi result
//     return mat4_decompose(self, scale, rotation, translation)
// }
// cc.mat4.createIdentity = function () {
//     // WARN: maybe multi result
//     return cc.mat4.new(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0)
// }
// cc.mat4.createTranslation = function (translation, dst) {
//     assert(type(translation) === "table" && type(dst) === "table", "The type of input parameters should be table")
//     dst = cc.mat4.createIdentity()
//     dst[13] = translation.x
//     dst[14] = translation.y
//     dst[15] = translation.z
//     return dst
// }
// cc.mat4.createRotation = function (q, dst) {
//     assert(type(q) === "table" && type(dst) === "table", "The type of input parameters should be table")
//     var x2 = q.x + q.x
//     var y2 = q.y + q.y
//     var z2 = q.z + q.z
//     var xx2 = q.x * x2
//     var yy2 = q.y * y2
//     var zz2 = q.z * z2
//     var xy2 = q.x * y2
//     var xz2 = q.x * z2
//     var yz2 = q.y * z2
//     var wx2 = q.w * x2
//     var wy2 = q.w * y2
//     var wz2 = q.w * z2
//     dst[1] = 1.0 - yy2 - zz2
//     dst[2] = xy2 + wz2
//     dst[3] = xz2 - wy2
//     dst[4] = 0.0
//     dst[5] = xy2 - wz2
//     dst[6] = 1.0 - xx2 - zz2
//     dst[7] = yz2 + wx2
//     dst[8] = 0.0
//     dst[9] = xz2 + wy2
//     dst[10] = yz2 - wx2
//     dst[11] = 1.0 - xx2 - yy2
//     dst[12] = 0.0
//     dst[13] = 0.0
//     dst[14] = 0.0
//     dst[15] = 0.0
//     dst[16] = 1.0
//     return dst
// }
